import { tw } from '@ds/utils/tailwind'

export const SQUARE_CLASS = tw`aspect-square`
export const ALT_MD_SMALL_ALL_CLASS = tw`md:h-[var(--carousel-small-item-size)] md:w-[var(--carousel-small-item-size)] md:!max-h-[var(--carousel-small-item-size)] md:!max-w-[var(--carousel-small-item-size)]`
export const SMALL_ALT_ITEM_SIZE_CLASS = tw`${SQUARE_CLASS} !h-[var(--carousel-small-item-size)] w-[var(--carousel-small-item-size)] !max-h-[var(--carousel-small-item-max-size)] !max-w-[var(--carousel-small-item-max-size)] ${ALT_MD_SMALL_ALL_CLASS}`
